// assets/wishlist.js
(() => {
  const STORAGE_KEY = 'h29:wishlist';
  const USE_SESSION = true;
  const MAX_ITEMS_RENDER = 50;

  const storage = USE_SESSION ? window.sessionStorage : window.localStorage;

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const $ = (sel, root = document) => root.querySelector(sel);

  function readList() {
    try {
      const raw = storage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(String) : [];
    } catch {
      return [];
    }
  }

  function writeList(list) {
    storage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { list } }));
  }

  function normalizeHandle(h) {
    return String(h || '').trim();
  }

  function toggle(handle) {
    handle = normalizeHandle(handle);
    if (!handle) return readList();

    const list = readList();
    const idx = list.indexOf(handle);

    if (idx >= 0) list.splice(idx, 1);
    else list.unshift(handle);

    writeList(list);
    return list;
  }

  function setButtonState(btn, active) {
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.classList.toggle('is-active', active);

    const iconOn = btn.querySelector('[data-wishlist-icon="on"]');
    const iconOff = btn.querySelector('[data-wishlist-icon="off"]');
    if (iconOn) iconOn.classList.toggle('hidden', !active);
    if (iconOff) iconOff.classList.toggle('hidden', active);
  }

  function syncAllButtons() {
    const list = readList();

    $$('[data-wishlist-toggle][data-product-handle]').forEach((btn) => {
      const handle = normalizeHandle(btn.getAttribute('data-product-handle'));
      setButtonState(btn, list.includes(handle));
    });

    $$('[data-wishlist-count]').forEach((el) => {
      el.textContent = String(list.length);
      el.classList.toggle('hidden', list.length === 0);
    });
  }

  // Delegation: funktioniert überall (Listing, PDP, Ajax-Rebuilds)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle][data-product-handle]');
    if (!btn) return;

    e.preventDefault();
    const handle = btn.getAttribute('data-product-handle');
    toggle(handle);
    syncAllButtons();
  });

  window.addEventListener('wishlist:changed', syncAllButtons);
  document.addEventListener('DOMContentLoaded', syncAllButtons);

  async function fetchCardHTML(handle) {
  const url = `/products/${encodeURIComponent(handle)}?view=wishlist-card`;

  const res = await fetch(url, {
    method: 'GET',
    headers: { Accept: 'text/html' },
    cache: 'no-store',
  });

  if (!res.ok) throw new Error(`wishlist-card failed for ${handle} (${res.status})`);
  return res.text();
}

async function mapLimit(items, limit, mapper) {
  const results = new Array(items.length);
  let idx = 0;

  const workers = Array.from({ length: Math.min(limit, items.length) }, async () => {
    while (idx < items.length) {
      const cur = idx++;
      try {
        results[cur] = await mapper(items[cur], cur);
      } catch (e) {
        results[cur] = '';
        console.warn('[wishlist] card error', items[cur], e);
      }
    }
  });

  await Promise.all(workers);
  return results;
}

async function renderWishlistPage() {
  const root = document.querySelector('[data-wishlist-page]');
  if (!root) return;

  const grid = root.querySelector('[data-wishlist-grid]');
  const empty = root.querySelector('[data-wishlist-empty]');
  if (!grid || !empty) return;

  const list = readList();
  const handles = list.map(h => String(h).trim()).filter(Boolean).slice(0, MAX_ITEMS_RENDER);

  if (handles.length === 0) {
    grid.innerHTML = '';
    empty.classList.remove('hidden');
    return;
  }

  empty.classList.add('hidden');
  const htmlParts = await mapLimit(handles, 4, fetchCardHTML);

  const html = htmlParts.filter(Boolean).join('');
  grid.innerHTML = html;
  syncAllButtons();
}

  document.addEventListener('DOMContentLoaded', renderWishlistPage);
  window.addEventListener('wishlist:changed', renderWishlistPage);
})();